import type { gqlV2 } from '@vrplatform/data';
import type { Maybe } from '@vrplatform/utils';
import { orderByContact } from '@vrplatform/ui-common';

export const getContactUserAccess = (
  contact: gqlV2.contact,
  tenantId: string
) => {
  const userAccess = contact
    .userAccess({
      order_by: [{ contact: orderByContact[1] }],
      where: {
        user: {
          memberships: {
            tenantId: { _eq: tenantId },
          },
        },
      },
    })
    .map((access) => {
      const membership = access.user.memberships({
        where: {
          tenantId: { _eq: tenantId },
          role: { _eq: 'owner' },
        },
        order_by: [{ createdAt: 'desc' }],
        limit: 1,
      })[0];

      return {
        userId: access.userId,
        email: access.user.email!,
        lastInvitedAt: membership?.lastInvitedAt,
        status:
          (membership?.status as Maybe<
            'active' | 'inactive' | 'unconfirmed'
          >) || 'inactive',
      };
    })[0];

  return (userAccess || null) as typeof userAccess | null;
};
